import React from 'react';

export const SupportIcon = () => (
  <div
    style={{
      marginRight: '10px',
      height: '20px',
      width: '20px',
      backgroundImage: 'url("/images/support-round.svg")',
      backgroundSize: '19px 19px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'inline-block'
    }}
  />
);
